var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-section',{staticClass:"device-container"},[_c('div',{staticClass:"image-box"},[_c('div',{staticClass:"image-container"},[_c('el-image',{attrs:{"src":_vm.appImageSrc,"lazy":""}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42fc0fbe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/devices/components/DeviceApplicationImageCard.vue
// module id = null
// module chunks = 